import { PermissionsEnum } from "@/auth/interfaces";
import { SAVE_FLOTA_PEMISSIONS } from "@/erp/sytem-sttings/flotas/shared/constants";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
  hasAllPermissions,
  useCheckPermissions,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import { useFetchFlotas } from "@/shared/actions/erp";
import { GeneralTable, SingleTableBoxScene } from "@/shared/components/ui";
import { Flota } from "@/shared/interfaces/erp/mantenimiento-operaciones";
import { Assignment, Close, Edit } from "@mui/icons-material";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAsignarZonaFlota } from "../../shared";
import CustomMapFlota from "../../shared/components/CustomMapFlota/CustomMapFlota";
import { useTableColumnsFlotas } from "../../shared/hooks";

export type FlotasPageProps = {};

const FlotasPage: React.FC<FlotasPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_view_flota);
  const returnUrlFlotasPagFlotasPage =
    ROUTER_PATHS.mantenimientoOperaciones.flotaNav;
  const navigate = useNavigate();

  const [modal, setModal] = useState<boolean>(true);
  //const [listaZonas, setListaZonas] = useState<Zone[]>([]);

  //const [flotaSelect, setFlotaSelect] = useState<Flota | null>(null);
  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const {
    /// todas las zonas
    setFlotaSelect,
    flotaSelect,
    zones: zonesPagingRes,
    setListaZonas,
  } = useAsignarZonaFlota();

  ///* table -----------------------
  const { pagination, searchTerm, setPagination } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data -----------------------
  const {
    data: flotasPagingRes,
    isLoading,
    isRefetching,
  } = useFetchFlotas({
    page: pageIndex + 1,
    page_size: pageSize,
    nombre: searchTerm,
    ...filterObject,
    filterByState: false,
  });

  ///* handlers -----------------------
  const onEdit = (original: Flota) => {
    navigate(`${returnUrlFlotasPagFlotasPage}/editar/${original.id_flota}`);
  };

  ///* columns -----------------------
  const { columnsFlota } = useTableColumnsFlotas({ enableStateSwitch: true });

  ///* store
  return (
    <>
      <SingleTableBoxScene
        title="Flotas"
        urlRedirect={`${returnUrlFlotasPagFlotasPage}/crear`}
        enableRedirect={hasAllPermissions([
          ...SAVE_FLOTA_PEMISSIONS,
          PermissionsEnum.api_add_flota,
        ])}
      >
        {/* <CustomSearch
          onChange={onChangeFilter}
          value={globalFilter}
          text="por nombre de Flota"
        /> */}

        <GeneralTable<Flota>
          columns={columnsFlota}
          data={flotasPagingRes?.data?.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={flotasPagingRes?.data?.count}
          ///* filters
          enableManualFiltering={true}
          enableSorting={false}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableGlobalFilter={false}
          // // actions ========
          enableColumnActions={hasAllPermissions([
            ...SAVE_FLOTA_PEMISSIONS,
            PermissionsEnum.api_change_flota,
          ])}
          actionsColumnSize={TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL}
          // crud
          canEdit={false}
          canDelete={false}
          enableEditing={true}
          showCustomActionBtnSpace={true}
          customActionBtnSpace={(data) => {
            return (
              <>
                <Grid container>
                  <Grid item>
                    <Tooltip title={"Editar"}>
                      <IconButton color="inherit" onClick={() => onEdit(data)}>
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  </Grid>

                  <Tooltip title="Asignar Zona">
                    <IconButton
                      color="primary"
                      onClick={() => {
                        console.log(data);

                        setFlotaSelect(data);
                        setModal(true);

                        if (data?.zonas) {
                          const codigosSet = new Set(data.zonas);
                          const listaObjet = zonesPagingRes.filter((item) =>
                            codigosSet.has(item.codigo),
                          );
                          setListaZonas(listaObjet);
                        } else {
                          setListaZonas([]);
                        }
                      }}
                    >
                      <Assignment />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </>
            );
          }}
        />
      </SingleTableBoxScene>

      {/*Modal asignar zonas*/}
      {modal && flotaSelect && (
        <Dialog
          open={modal}
          scroll="paper"
          onClose={() => {
            setModal(false);
            setFlotaSelect(null);
          }}
          sx={{
            "& .MuiDialog-paper": {
              width: "100%",
              minWidth: "90%",
              margin: "0px",
              height: "100vh",
              minHeight: "80vh",
              borderRadius: 1,
              overflow: "hidden",
            },
          }}
        >
          <DialogTitle id="scroll-dialog-title">
            <Grid container justifyContent={"space-between"}>
              <Grid item>{`Flota: '${flotaSelect.nombre}'`}</Grid>
              <Grid item>
                <IconButton
                  onClick={() => {
                    setModal(false);
                    setFlotaSelect(null);
                  }}
                >
                  <Close />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <CustomMapFlota
              /* listaZonas={listaZonas}
                setListaZonas={setListaZonas} */
              esModal={true}
              //flota={flotaSelect}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default FlotasPage;
